export default __webpack_public_path__ + "assets/images/69e10dcdabda3462adf922a696859de9.png";